import api from "./api";

export const getAutoTradeStatus = async () => {
    try {
        const response = await api.get("/auto-trade/status");
        return response.data || { enabled: false };
    } catch (error) {
        console.error("Error fetching auto-trade status", error);
        return { enabled: false };
    }
};

export const getPnlHeatMap = async (days: number = 365, mode?: 'paper' | 'live') => {
    try {
        const params = new URLSearchParams({ days: days.toString() });
        if (mode) params.append('mode', mode);
        const response = await api.get(`/auto-trade/pnl-heatmap?${params}`);
        return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        console.error("Error fetching PnL Heatmap", error);
        return [];
    }
};

export const updateAutoTradeSetting = async (key: string, value: any) => {
    const response = await api.post("/auto-trade/settings", { key, value });
    return response.data;
};

export const getTodayAutoTradeLogs = async (mode?: 'paper' | 'live', date?: string, page = 1, limit = 20, status?: string) => {
    try {
        const params = new URLSearchParams();
        if (mode) params.append('mode', mode);
        if (date) params.append('date', date);
        if (status) params.append('status', status);
        params.append('page', page.toString());
        params.append('limit', limit.toString());

        const response = await api.get(`/auto-trade/logs/today?${params.toString()}`);
        return response.data || { logs: [], pagination: { total: 0, page, limit }, stats: {} };
    } catch (error) {
        console.error("Error fetching logs", error);
        return { logs: [], pagination: { total: 0, page, limit }, stats: {} };
    }
};

export const getAutoTradeHistory = async (page = 1, limit = 20) => {
    try {
        const response = await api.get(`/auto-trade/history?page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching history", error);
        return { logs: [], total: 0 };
    }
};

export const emergencyStop = async () => {
    const response = await api.post("/auto-trade/emergency-stop");
    return response.data;
};

export const resumeTrading = async () => {
    const response = await api.post("/auto-trade/resume-trading");
    return response.data;
};
